<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center" min-width="120" prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.img"
          >
          </img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="activityName"
        label="活动名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.activityName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="名称" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.desc || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="link"
        label="活动链接"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.link || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否启用"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 1">启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 0">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="expiredIn"
        label="结束时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.expiredIn) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="warning" @click="editContent(scope.row)"
            >活动内容</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNum"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="图片:" prop="cover">
          <base-upload
            class="upload"
            :cover="form.img"
            :action="action"
            wSize="47"
            hSize="47"
            :width="'138.5px'"
            :height="'138.5px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="活动名称" prop="activityName">
          <el-input v-model="form.activityName"></el-input>
        </el-form-item>
        <el-form-item label="活动说明" prop="desc">
          <el-input v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="活动链接" prop="link">
          <el-input v-model="form.link"></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker
            v-model="form.expiredIn"
            type="datetime"
            :editable="false"
            placeholder="请输入结束时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.status" placeholder="请选择是否推">
            <el-option
              v-for="item in enables"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑活动内容"
      :visible.sync="isEditContent"
      width="80%"
      @close="close"
    >
      <div class="home">
        <!-- <h3>AV图文配置</h3>
        &nbsp;&nbsp;&nbsp; -->
        <el-button type="warning" size="mini" @click="openAddImage"
          >图片上传</el-button
        >
        &nbsp;&nbsp;&nbsp;
        <!-- <el-button type="success" size="mini" @click="getEditorData"
          >预览页面</el-button
        > -->
        &nbsp;&nbsp;&nbsp;
        <el-button type="danger" size="mini" @click="cleanData"
          >清除数据</el-button
        >
        <br /><br />
        <div id="editor" class="wangEditor"></div>
        <!-- <h3>内容预览</h3> -->
        <!-- <textarea name="" id="" cols="170" rows="20" readonly v-model="editorData"></textarea> -->
        <!--预览-->
        <look ref="look"></look>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="isEditContent = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditContent">确 定</el-button>
      </div>
    </el-dialog>
    <add-image ref="addImage"></add-image>
  </div>
</template>
<script>
import API from "@/api";
import wangEditor from "wangeditor";
import Look from "../../avcomment/avCommentConfig/components/look";
import AddImage from "../../avcomment/avCommentConfig/components/addImage";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  components: {
    Look,
    AddImage,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      rules: {
        activityName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        // content: [
        //   { required: true, message: "请输入活动内容", trigger: "blur" },
        // ],
      },
      dialogTitle: "",
      dialogVisible: false,
      form: {
        activeID: undefined,
        activityName: "",
        img: "",
        link: "",
        desc: "",
        // content: "",
        status: 1,
        sort: undefined,
        expiredIn: "",
      },
      topicId: "",
      isEditContent: false,
      editorDom: "",
      editor: null,
      editorData: "",
      editId: "",
      graphic: "",
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNum = 1;
      }
      API.getActivity(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.img = res.data.coverImg;
    },
    // 编辑活动内容
    editContent(row) {
      // console.log(row.content);
      this.editId = row.id;
      this.isEditContent = true;
      if (!this.editorDom) {
        setTimeout(() => {
          this.editorDom = new wangEditor(`#editor`);
          // 配置 onchange 回调函数，将数据同步到 vue 中
          this.editorDom.config.onchange = (newHtml) => {
            this.editorData = newHtml;
          };
          this.editorDom.create();
          // if (this.graphic != "" && this.graphic != "") {
          //   this.editorDom.txt.html(this.graphic);
          // }
          this.editorDom.txt.html(row.content);
          this.editor = this.editorDom;
        });
      } else {
        this.editorDom.txt.html(row.content);
      }
    },
    // 新增标签配置
    addAndEdit(param) {
      this.editId = param.id;
      this.dialogVisible = true; // 打开新增、编辑对话框
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.activeID = param.id;
        this.form.activityName = param.activityName;
        this.form.img = param.img;
        this.form.desc = param.desc;
        this.form.link = param.link;
        // this.form.content = param.content;
        this.form.expiredIn = param.expiredIn;
        this.form.status = param.status;
        this.form.sort = param.sort ? param.sort : undefined;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addActivity(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.editActive(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    openAddImage() {
      this.$refs.addImage.open();
    },
    // getEditorData() {
    //   // 通过代码获取编辑器内容
    //   // let data = this.editor.txt.html()
    //   // this.$refs.look.open(data, this.id)
    // },
    cleanData() {
      // this.id = ''
      this.graphic = "";
      this.editor.txt.html("");
    },
    confirmEditContent() {
      // console.log(this.editor.txt.html());
      if (!this.editor.txt.html()) {
        this.$message({
          type: "error",
          message: "请输入活动内容",
        });
        return;
      }
      let req = {
        activeID: this.editId,
        content: this.editor.txt.html(),
      };
      API.editActive(req)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.isEditContent = false;
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "编辑失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "编辑失败",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.activeID = "";
      this.form.activityName = "";
      this.form.img = "";
      this.form.desc = "";
      this.form.link = "";
      // this.form.content = "";
      this.form.expiredIn = "";
      this.form.status = 1;
      this.form.sort = undefined;
      this.dialogVisible = false;
    },
    close() {
      this.editId = "";
      // this.editor = "";
      this.graphic = "";
      this.editorDom.txt.html("");
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNum) {
      this.params.pageNum = pageNum;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
  width: 100%;
}
/deep/ .el-date-editor {
  width: 100% !important;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item {
  display: flex;
  align-items: center;
}
.wangEditor {
  position: initial !important;
  /deep/ .w-e-text-container {
    height: 500px !important;
  }
}
</style>
